<template>
<div>
  <columns class="pointer" @click="expanded = !expanded">
    <column>
      <flex class="justify-between">
        <h4 class="is-size-5 has-text-info">CWE-{{ checkpoint.cwe.number }}</h4>
        <risk-tag v-if="!resolved" :level="checkpoint.risk_level"/>
        <div v-else class="tags has-addons is-rounded">
          <span class="tag is-rounded">Status</span>
          <span class="tag is-rounded" :class="{
            'is-warning': status === 'False Positive',
            'is-success': status === 'Resolved',
          }">{{ status }}</span>
        </div>
      </flex>
    </column>
  </columns>
  <transition name="fade" mode="out-in">
    <div v-if="expanded">
      <columns>
        <column>
          <p>{{ checkpoint.cwe.description }}</p>
        </column>
      </columns>
      <columns>
        <column>
          <p class="has-text-weight-bold has-text-info">Corrective Measures</p>
          {{ checkpoint.value }}
        </column>
      </columns>

      <slot />
    </div>
  </transition>
</div>
</template>
<script>

export default {
  
  props: {
    checkpoint: {
      type: Object,
      default: () => ({})
    },
    resolved: {
      type: Boolean,
      default: false
    },
    falsePositive: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    expanded: false
  }),

  computed: {
    status() {
      if(this.falsePositive) return 'False Positive'
      if(this.resolved) return 'Resolved'
    }
  }

}
</script>